<template lang="pug">
  //- Barra de filtros de búsqueda
  .b2b-filters
    b2b-search-bar
      div.header(slot='header')
        span.dateHeader {{ $t('accounting_closes.entity_table.start_date') }}
        ods-date-picker(
          v-model='dateTimePickerValue',
          type='datetimerange',
          :picker-options='pickerOptions2',
          @change='getDateTimePickerValue',
          :range-separator='$t("msg_generics.datepicker.separator")',
          :start-placeholder='$t("msg_generics.datepicker.start_placeholder")',
          :end-placeholder='$t("msg_generics.datepicker.end_placeholder")',
          :format='$t("date_format_long_datepicker")',
          :canSelectSeconds='true',
          :default-time="['00:00:00', '23:59:59']",
          prefix-icon='prefix-icon-date-time-picker',
          :showFooterButtons='true',
          align='right')
        ods-tooltip.ods-ml-4(:content='$t("buttons.refresh_tooltip")', placement='bottom')
          ods-button(
            icon='ods-icon-refresh',
            size='medium',
            circle,
            @click="activeRefreshResults")
        ods-tooltip(:content='$t("accounting_closes.new_accounting_tooltip")', placement='bottom')
          ods-button(
              size='medium',
              icon='ods-icon-upload',
              @click.native='handleNewAccounting')
              | {{ $t('accounting_closes.new_accounting') }}
      div(slot='body')
        ods-form.b2b-filters__area(
          :model='filterForm',
          :rules='rules',
          ref='filterForm',
          @submit.native.prevent='')
          ods-form-item.first-input(prop='firstValue')
            //- b2b-select
            ods-select(
              :no-match-text='$t("msg_generics.no_match")',
              v-model='filterForm.firstValue',
              :placeholder='$t("msg_generics.advanced_search")',
              @change='getFirstValue')

              ods-option(
                v-for='option in options',
                :key='option.col',
                :disabled='option.selected',
                :label='$t(option.value)',
                :value='option')

          transition(name='ods-fade-in-linear', mode='out-in')
            div(v-show='filterForm.firstValue')
              //- Select type
              div(v-if="selected.componente === 'select'")
                ods-form-item.others-input(prop='secondValueSelect')
                  ods-select(v-if="selected.prop === 'projectId'"
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.id',
                      :label='option.name',
                      :value='option.id')
                  ods-select(v-if="selected.prop === 'buyerId'"
                    :no-match-text='$t("msg_generics.no_match")',
                    v-model='filterForm.secondValueSelect',
                    filterable,
                    :filter-method='filterPartiesBuyer',
                    :placeholder='$t(selected.placeholder)',
                    @change='getSecondValue')
                    ods-option(
                      v-for='option in selected.options',
                      :key='option.id',
                      :label="(option.taxIdentificationNumber?option.taxIdentificationNumber + ' - ':'') + option.tradeName",
                      :value='option.id')
              //- INVOICE NUMBER
              div(v-else-if="selected.componente === 'input' && (selected.prop === 'invoiceNumber')")
                ods-form-item.others-input(prop='invoiceNumber')
                  ods-input(
                    :placeholder='$t(selected.placeholder)',
                    v-model.trim='filterForm.invoiceNumber',
                    @input='getSecondValue')
              //- Input type
              div(v-else-if="selected.componente === 'input' && selected.prop !== 'invoiceNumber'")
                ods-form-item.others-input(prop='secondValue')
                  ods-input(
                    :placeholder='$t(selected.placeholder)',
                    v-model='filterForm.secondValue',
                    @input='getSecondValue')

              //- Date Type
              div(v-else-if="selected.componente === 'date'")
                ods-form-item(prop='filterDatePickerValue')
                  ods-date-picker(
                    v-model='filterForm.filterDatePickerValue',
                    type='daterange',
                    :picker-options='pickerOptions2',
                    @change='getDateRangePickerValue',
                    :range-separator='$t("msg_generics.datepicker.separator")',
                    :start-placeholder='$t("msg_generics.datepicker.start_placeholder")',
                    :end-placeholder='$t("msg_generics.datepicker.end_placeholder")',
                    :format='$t("date_format_calendar")',
                    prefix-icon='prefix-icon-date-time-picker'
                    align='right')

          transition(name='ods-fade-in-linear', mode='out-in')
            div(v-show='filterForm.firstValue')
              ods-button(
                icon='ods-icon-plus',
                size='medium',
                circle,
                @click.native="onSubmit('filterForm')")

    .b2b-filters__container(v-if='listSelectedFiltersAccountingCloseDraft.length > 0')
      transition-group.b2b-filters__group(
        name='ods-fade-in-linear',
        tag='div')
        ods-popover(
          key='icon-delete-filters',
          placement='top-start',
          trigger='hover',
          :content='$t("msg_generics.popover_clean_filters")')
          ods-button.clean-filters(
            slot='reference',
            type='neutral',
            size='small',
            icon='ods-icon-delete'
            @click='handleDeleteAllFilters')

        .b2b-filters__button(
          v-for='(filter, index) in listSelectedFiltersAccountingCloseDraft',
          :key='index')
          b2b-filter-button-accounting-close-draft(
            :filter='filter',
            @closeTag='resetSelectedOneOption')
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bSearchBar from '@/components/B2bSearchBar'
import B2bFilterButtonAccountingCloseDraft from './B2bFilterButtonAccountingCloseDraft'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-filters-accountingclose-draft',

  props: {
    filterOptions: {
      type: Object,
      required: true
    }
  },

  mixins: [Utils],

  components: {
    B2bSearchBar,
    B2bFilterButtonAccountingCloseDraft
  },

  data () {
    const _this = this
    return {
      // DatePicker
      dateTimePickerValue: [],
      tid: null,

      pickerOptions2: {
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: this.$t('msg_generics.datepicker.today'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'today')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_week'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastWeek')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_month'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastMonth')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_three_months'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastThreeMonths')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_year'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastYear')
            }
          },
          {
            text: this.$t('msg_generics.datepicker.last_two_year'),
            onClick (picker) {
              _this.getDateFromDateTimePicker(picker, 'lastTwoYear')
            }
          }
        ]
      },
      // Formulario
      filterForm: {
        secondValueWithoutMin: '',
        firstValue: '',
        invoiceNumber: '',
        secondValue: '',
        filterDatePickerValue: [],
        secondValueSelect: ''
      },
      selected: {},
      selectedFilters: [],
      options: {},

      // Reglas Validación
      rules: {
        invoiceNumber: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { min: 1, message: this.$t('msg_generics.min_three_letters') },
          { max: 40, message: this.$t('msg_generics.max_num_character', { max: 40 }), trigger: 'change' }
        ],
        filterDatePickerValue: [
          {
            required: true,
            message: this.$t('msg_generics.date_required'),
            trigger: 'change'
          }
        ],
        secondValue: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { min: 1, message: this.$t('msg_generics.min_three_letters') },
          { max: 50, message: this.$t('msg_generics.max_num_character', { max: 50 }), trigger: 'change' }
        ],
        secondValueSelect: [
          {
            required: true,
            message: this.$t('msg_generics.element_selected'),
            trigger: 'change'
          }
        ]
      }
    }
  },

  computed: {
    ...mapGetters([
      'activeUser',
      'queryAccountingCloseDraft',
      'listSelectedFiltersAccountingCloseDraft',
      'optionsFilterInvoiceNumberAccountingCloseDraft',
      'optionsFilterNameAccountingCloseDraft',
      'optionsFilterCloseDateAccountingCloseDraft',
      'optionsFilterStartDateAccountingCloseDraft',
      'optionsFilterEndDateAccountingCloseDraft',
      'optionsFilterNameChildCloseDraft',
      // Combos
      'optionsFilterService',
      'optionsFilterBuyerAccountingCloseDraft'
    ])
  },

  watch: {
    $route (to) {
      this.listSelectedFiltersAccountingCloseDraft = this.listSelectedFiltersAccountingCloseDraft // eslint-disable-line
    }
  },

  methods: {
    activeRefreshResults () {
      this.refreshResults()
    },
    ...mapActions([
      'getAccountingClosesDraft',
      'queryAccountingCloseDraftState',
      'listSelectedFiltersAccountingCloseDraftState',
      'optionsFilterBuyerAccountingCloseDraftState',
      'getOptionsService',
      'optionsServicesEnabledState',
      'getOptionsFilterPartyME'
    ]),

    /* Redirige a un nuevo cierre */
    handleNewAccounting () {
      router.push({
        name: 'new-accounting'
      })
    },
    getFirstValue (data) {
      this.filterForm.invoiceNumber = ''
      this.filterForm.secondValueWithoutMin = ''
      this.filterForm.secondValue = ''
      this.filterForm.secondValueSelect = ''
      this.$refs.filterForm.clearValidate()
      this.selected = data
      const aux = []
      this.optionsFilterBuyerAccountingCloseDraftState(aux)
    },

    getSecondValue (data) {
      if (this.selected.componente === 'select') {
        if (this.selected.prop === 'projectId') {
          const option = this.selected.options.find(function (elem) {
            return elem.id === data
          })
          this.selected.query = option.id
          this.selected.labelText = option.name
        } else if (this.selected.prop === 'statusId') {
          const option = this.selected.options.find(function (elem) {
            return elem.id === data
          })
          this.selected.query = option.id
          this.selected.labelText = this.$t('invoice_status.' + option.code)
        } else if (
          this.selected.prop === 'buyerId' ||
          this.selected.prop === 'sellerId'
        ) {
          const option = this.selected.options.find(function (elem) {
            return elem.id === data
          })
          this.selected.query = option.id
          this.selected.labelText = option.tradeName
        }
      } else if (this.selected.componente === 'input') {
        this.selected.query = data
        this.selected.labelText = data
      } else if (this.selected.componente === 'date') {
        this.selected.labelText = data.query
      }

      this.$refs.filterForm.clearValidate()
    },

    getThirdValue (data) {
      console.log('data:', data)
    },

    // Filtro Fechas Emision
    getDateRangePickerValue () {
      console.log('FILTRO SELECCIONADO ', this.selected)
      console.log(
        'getDatePickerValue: ',
        this.filterForm.filterDatePickerValue
      )
      this.selected.query = this.filterForm.filterDatePickerValue
      this.getSecondValue(this.selected)
    },

    onSubmit (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const dataQuery = {
            query: {}
          }
          const load = this.$loading({
            lock: true,
            text: this.$t('msg_generics.filter_selected')
          })
          try {
            console.log('1 Filtro Seleccionado: ', this.selected)
            const column = this.selected.prop

            switch (column) {
              case 'projectId':
                this.queryAccountingCloseDraft.projectId = this.selected.query
                break
              case 'buyerId':
                this.queryAccountingCloseDraft.buyerId = this.selected.query
                break
              case 'invoiceNumber':
                this.queryAccountingCloseDraft.invoiceNumber = this.selected.query.trim()
                break
              case 'statusId':
                this.queryAccountingCloseDraft.statusId = this.selected.query
                break
              case 'name':
                this.queryAccountingCloseDraft.name = this.selected.query.trim()
                break
              case 'childAccountingCloseName':
                this.queryAccountingCloseDraft.childAccountingCloseName = this.selected.query
                break
              default:
                break
            }

            this.selectedFilters = this.listSelectedFiltersAccountingCloseDraft
            this.selected.selected = true
            this.selectedFilters.push(this.selected)
            await this.listSelectedFiltersAccountingCloseDraftState(
              this.selectedFilters
            )

            this.selected = {}
            this.$refs[formName].resetFields()
            this.filterForm.filterDatePickerValue = []
            this.queryAccountingCloseDraft.page = 0
            await this.queryAccountingCloseDraftState(
              this.queryAccountingCloseDraft
            )
            dataQuery.query = this.queryAccountingCloseDraft

            const response = await this.getAccountingClosesDraft(dataQuery)
            this.totalResults = response.totalElements
          } catch (error) {
            console.log('onSubmit FILTER CATCH: ', error)
            this.getNotificationErrorMessage(error)
            this.handleDeleteAllFilters()
          } finally {
            this.initForm()
            load.close()
          }
        } else {
          console.log('error submit!!')
        }
      })
    },

    async getDateTimePickerValue () {
      console.log('getDateTimePickerValue: ', this.dateTimePickerValue)
      if (!this.dateTimePickerValue) {
        this.queryAccountingCloseDraft.startDateFrom = ''
        this.queryAccountingCloseDraft.endDateTo = ''
      } else {
        this.queryAccountingCloseDraft.startDateFrom = this.dateTimePickerValue[0]
        this.queryAccountingCloseDraft.endDateTo = this.dateTimePickerValue[1]
      }

      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.filter_date')
      })
      try {
        await this.queryAccountingCloseDraftState(
          this.queryAccountingCloseDraft
        )
        dataQuery.query = this.queryAccountingCloseDraft
        const response = await this.getAccountingClosesDraft(dataQuery)
        this.totalResults = response.totalElements
      } catch (error) {
        console.log('onSubmit FILTER CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async refreshResults () {
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.load_init')
      })
      try {
        dataQuery.query = this.queryAccountingCloseDraft
        const response = await this.getAccountingClosesDraft(dataQuery)
        this.totalResults = response.totalElements
      } catch (error) {
        console.log('onSubmit FILTER CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    getFirstRangeDate () {
      const start = new Date()
      const end = new Date()
      // Si es superadmin 30 dias de lo contrario 90 dias
      if (this.activeUser.data.isSuperAdmin) {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      } else {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
      }

      this.dateTimePickerValue.push(start)
      this.dateTimePickerValue.push(end)
    },

    async handleDeleteAllFilters () {
      console.log(this.selectedFilters)
      this.selectedFilters = []
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.filter_delete_all')
      })
      try {
        this.selectedFilters = this.listSelectedFiltersAccountingCloseDraft.map(
          item => {
            item.labelText = ''
            item.query = ''
            item.selected = false
            return item
          }
        )

        console.log('CLEAR FILTERS: ', this.selectedFilters)
        await this.listSelectedFiltersAccountingCloseDraftState(
          this.selectedFilters
        )

        if (!this.dateTimePickerValue) {
          this.queryAccountingCloseDraft.startDateFrom = ''
          this.queryAccountingCloseDraft.endDateTo = ''
        } else {
          this.queryAccountingCloseDraft.startDateFrom = this.dateTimePickerValue[0]
          this.queryAccountingCloseDraft.endDateTo = this.dateTimePickerValue[1]
        }

        this.queryAccountingCloseDraft.projectId = ''
        this.queryAccountingCloseDraft.buyerId = ''
        this.queryAccountingCloseDraft.invoiceNumber = ''
        this.queryAccountingCloseDraft.name = ''
        this.queryAccountingCloseDraft.childAccountingCloseName = ''

        this.queryAccountingCloseDraft.startDateTo = ''
        this.queryAccountingCloseDraft.endDateFrom = ''

        await this.queryAccountingCloseDraftState(
          this.queryAccountingCloseDraft
        )
        dataQuery.query = this.queryAccountingCloseDraft
        const response = await this.getAccountingClosesDraft(dataQuery)
        this.totalResults = response.totalElements
        this.selectedFilters = []
        await this.listSelectedFiltersAccountingCloseDraftState(
          this.selectedFilters
        )

        // Reseteamos la prop selected de los filtros
        this.resetSelectedOptions(this.options)
      } catch (error) {
        console.log('getUsers CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        this.initForm()
        load.close()
      }
    },
    async getBuyerResults (data) {
      const requestParty = {
        role: 'BUYER',
        projectId: [this.queryAccountingCloseDraft.projectId],
        page: 0,
        size: 1000,
        tradeNameOrTaxId: data
      }
      const response = await this.getOptionsFilterPartyME(requestParty)
      this.selected.options = response
      this.auxListPartiesBuyer = response
      this.optionsFilterBuyerAccountingCloseDraftState(response)
    },
    async filterPartiesBuyer (data) {
      try {
        // Si el valor introducido tiene exactamente 3 caracteres se obtiene la lista a través de servicio REST de empresas
        if (data.length >= 3) {
          clearTimeout(this.tid)
          this.tid = setTimeout(this.getBuyerResults, 1000, data)
        } else { // Si el valor introducido tiene menos de 3 caracteres, no se filtra
          this.auxListPartiesBuyer = []
          this.optionsFilterBuyerAccountingCloseDraftState(
            this.auxListPartiesBuyer
          )
        }
      } catch (error) {
        console.log('filterPartiesBuyer CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },

    // Metodo lanzado al capturar el evento de closeTag
    async resetSelectedOneOption (data) {
      this.resetOneOption(this.options, data.filter)
      await this.listSelectedFiltersAccountingCloseDraftState(data.listAfterRemove)
      this.initForm()
    },

    initForm () {
      if (!this.options.name.selected) {
        this.filterForm.firstValue = this.options.name
        this.selected = this.filterForm.firstValue
      } else {
        this.filterForm.firstValue = ''
        this.selected = this.filterForm.firstValue
      }
      this.queryAccountingCloseDraft.buyerId = ''
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$i18n.messages.es.error.e401
          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        case 404:
          errorSms = error.data.message
          break
        case 409:
          errorSms = error.data.message
          break
        case 500:
          errorSms = this.$i18n.messages.es.error.e500
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    // Creamos una copia del json que contiene los datos de los filtros y trabajamos con la copia
    this.options = JSON.parse(JSON.stringify(this.filterOptions))

    // Ponemos el estado de selected a true si ya estaba seleccionado el filtro
    this.checkListFilterSelected(this.options, this.listSelectedFiltersAccountingCloseDraft)

    // Si el usuario sólo tiene un servicio, quitamos el filtro de servicios
    if (this.optionsFilterService.length < 2) {
      delete this.options.projectId
    }
    this.initForm()
    if (this.queryAccountingCloseDraft.startDateFrom) {
      this.dateTimePickerValue.push(this.queryAccountingCloseDraft.startDateFrom)
      this.dateTimePickerValue.push(this.queryAccountingCloseDraft.endDateTo)
    }
    try {
      await this.queryAccountingCloseDraftState(this.queryAccountingCloseDraft)
    } catch (error) {
      this.getNotificationErrorMessage(error)
    }
  },

  updated () {
    // Si el usuario sólo tiene un servicio, quitamos el filtro de servicios
    if (this.optionsFilterService.length > 1) {
      this.options.projectId.options = this.optionsFilterService
    }
    this.options.buyerId.options = this.optionsFilterBuyerAccountingCloseDraft
    this.options.invoiceNumber.options = this.optionsFilterInvoiceNumberAccountingCloseDraft
    this.options.name.options = this.optionsFilterNameAccountingCloseDraft
    this.options.childAccountingCloseName.options = this.optionsFilterNameChildCloseDraft
    // La fecha del cierre va en la cabecera la quitamos del filtro
    // this.options.closeDateTime.options = this.optionsFilterCloseDateAccountingCloseDraft
  }
}
</script>

<style lang="scss" scoped>
::v-deep .ods-input__prefix {
  height: 72px !important;
}
::v-deep .ods-input__suffix {
  height: 72px !important;
}
.b2b-filters{
  ::v-deep .ods-tag--secondary {
    background-color: var(--color-bg-hover-2) !important;
    border-color: transparent !important;
    color: var(--color-bg-interactive) !important;
  }
::v-deep .ods-icon-close, body .ods-icon-close {

    position: relative;
    cursor: pointer;
    font-size: 12px !important;
    height: 8px;
    line-height: 1;
    vertical-align: middle;
    right: -1px;
    top: -4px;
    color: var(--color-bg-interactive);
}
::v-deep .ods-tag {

    display: inline-block;
    height: 24px;
    line-height: 14px;
    background-color: white;
    padding-top: 5px;
    font-size: 9px;
    color: var(--color-bg-interactive);
    border-radius: 6px;
    box-sizing: border-box;
    white-space: nowrap;
    text-transform: uppercase;
    font-family: soho, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, "微软雅黑", Arial, sans-serif;
    font-weight: 600;
    letter-spacing: 0.2px;
    border: 1px solid;
}
::v-deep .ods-select .ods-tag {
    display: inline-flex;
    margin: 2px 0 -52px 6px;
    .ods-tag__content {
      .ods-select__tags-text {
        text-transform: none;
      }
      max-width: 100%;
    min-width: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    width: calc(100% - 8px);
    display: inline-block;
    vertical-align: bottom;
    }
  }
  .b2b-filters__group {
    padding: 0 1.5rem 1.25rem 1.5rem;
    height: auto;
    background-color: white;
  }
  // background-color: var(--color-bg-primary);
  // border-top: .1rem solid $grey-2;
  // box-shadow: 0 .2rem .8rem 0 rgba(0, 0, 0, 0.08);

  .dateHeader {
    font-size: 12px;
    padding: 0 28px 0 20px;
    color: var(--color-txt-secondary);
  }

  .ods-button{
    display: inline;
    margin-right: rem(24);
  }

  ::v-deep &__area {
    display: flex;

    .ods-form-item {
      margin-bottom: 0;
      &__content {
        line-height: inherit;
      }
      &__error {
        top: rem(55);
      }
      input {
        max-width: rem(200);
      }
      select {
        max-width: rem(200);
      }
    }

    .first-input {
      margin-right: rem(32);
    }

    // Para los input que no sean datepicker,
    // colocar un margen igual a como si tuviese el botón del datepicker
    .others-input {
      margin-right: rem(16);
    }

    .ods-range-separator {
      padding: 0 rem(8);
    }
  }

  &__group {
    padding: 0 1.5rem 1.25rem 1.5rem;
    height: auto;

    .clean-filters {
      color: var(--color-status-info-400);
      .ods-icon-delete {
        margin-left: 0px;
      }
    }
  }

  &__button {
    margin: 0 0 0 1.25rem;
    display: inline-block;
    width: auto;
  }
}
</style>
